import { Navigate } from "react-router-dom";

const LibraryCoursesPage = () => {
  return <Navigate to="/courses" replace />;
};

export default LibraryCoursesPage;
